import {
  useApi,
  type GetIssueResponseDto,
  type SaveAttachmentDto,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseDeclineActionParams = {
  code: string;
  onSuccess: () => void;
};
type UseDeclineActionMutationParams = {
  id: string;
  note: string;
  attachments: SaveAttachmentDto[];
};

export function useDeclineAction({ code, onSuccess }: UseDeclineActionParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    GetIssueResponseDto,
    ExtendedAxiosError,
    UseDeclineActionMutationParams
  >({
    mutationKey: ['actions'],
    mutationFn: ({ id, ...rest }) =>
      api.issuesApi.declineAction(code, id, rest).then((r) => r.data),
    onSuccess: async (issue) => {
      queryClient.setQueriesData<GetIssueResponseDto>(
        { queryKey: ['issues', code], exact: true },
        () => ({ ...issue }),
      );
      await queryClient.invalidateQueries({
        queryKey: ['issues', code, 'timeline'],
      });
      onSuccess();
    },
  });
}
